import { Blue, White } from '@constants/color';
import { css } from '@emotion/react';

export const status = css({
  display: 'flex',
  flexDirection: 'row',
  columnGap: '8px',
  justifyContent: 'center',
  alignItems: 'center',
  width: '100%',
  height: '48px',
  backgroundColor: 'rgba(48, 54, 66, .7)',
  backdropFilter: 'blur(24px)',
  borderRadius: '4px',
  color: White.White10,
  fontSize: '20px',
  fontWeight: 500
});
export const statusFocused = css({
  backgroundColor: Blue.Blue60
});
